import React, { useState } from "react";
import TermsModal from "./TermsModal"; 
import { FaFacebookF, FaLinkedinIn, FaMediumM } from "react-icons/fa";
import ReferralModal from "./ReferralModal";
import demoPdf from '../assets/images/asdflo_demo.pdf';
import LogoWithSlogan from "./LogoWithSlogan";

const termsContent = (
  <>
    <p className="mb-2">Welcome to asdflo! By using our platform, you agree to the following terms and conditions. Please read them carefully.</p>
    <ul className="list-disc pl-5 space-y-2">
      <li>asdflo is a platform for connecting parents, professionals, and centers in the neurodiversity community.</li>
      <li>Your information is stored securely and is not shared with third parties except as required to provide services or by law.</li>
      <li>You are responsible for the accuracy of the information you provide.</li>
      <li>asdflo reserves the right to update these terms at any time. Notice will be provided for significant changes.</li>
      <li>For more information, contact us at info@asdflo.com.</li>
    </ul>
    <p className="mt-4">By using asdflo, you agree to abide by these terms. Thank you for being a part of our community!</p>
  </>
);

const privacyPolicyContent = (
  <>
    <p className="mb-2">Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our platform.</p>
    <h3 className="font-semibold mt-3 mb-1">Information Collection</h3>
    <ul className="list-disc pl-5 space-y-1">
      <li>Personal identification information (Name, email address, phone number, etc.)</li>
      <li>Professional details (for therapists, centers, etc.)</li>
      <li>Usage data and cookies.</li>
    </ul>
    <h3 className="font-semibold mt-3 mb-1">Use of Information</h3>
    <ul className="list-disc pl-5 space-y-1">
      <li>To provide and maintain our service.</li>
      <li>To notify you about changes to our service.</li>
      <li>To allow you to participate in interactive features.</li>
      <li>To provide customer support.</li>
    </ul>
    <h3 className="font-semibold mt-3 mb-1">Data Security</h3>
    <p>We use administrative, technical, and physical security measures to help protect your personal information.</p>
    <p className="mt-2">For any questions, contact us at info@asdflo.com.</p>
  </>
);

export default function Footer() {
  const [referralModal, setReferralModal] = useState({ open: false, role: null });
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");

  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalTitle("");
    setModalContent(null);
  };

  return (
    <footer className="w-full pt-8 pb-4 px-2 md:px-8 bg-gray-900 border-t border-gray-800 shadow-inner mt-12 text-gray-200">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center md:justify-between gap-6">
  
        {/* Logo and Brand */}
        <div className="flex flex-col items-center md:items-start">
          <LogoWithSlogan isFooter={true} />
        </div>
        {/* Main Footer Links */}
        <nav className="flex flex-wrap gap-4 justify-center items-center text-[15px] font-medium mb-3 md:mb-0">
          <a href="/about" className="hover:text-indigo-300 transition">About</a>
          <a href="mailto:info@asdflo.com" className="hover:text-indigo-300 transition">Contact</a>
          <a href="https://medium.com/@asdfloteam" className="hover:text-indigo-300 transition" target="_blank" rel="noopener noreferrer">Blog</a>
          <button 
            type="button" 
            className="hover:text-indigo-300 transition underline bg-transparent border-none p-0 m-0 text-inherit cursor-pointer"
            onClick={() => openModal("Terms & Conditions", termsContent)}
          >
            T&amp;C
          </button>
          <button 
            type="button" 
            className="hover:text-indigo-300 transition underline bg-transparent border-none p-0 m-0 text-inherit cursor-pointer"
            onClick={() => openModal("Privacy Policy", privacyPolicyContent)}
          >
            Privacy Policy
          </button>
          <a
            href={demoPdf}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-indigo-300 transition"
          >
            Product Demo
          </a>
        </nav>

        {/* Social Icons */}
        <div className="flex gap-4">
          <a href="https://www.facebook.com/profile.php?id=61575316464563" aria-label="Facebook" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500 text-xl transition-transform duration-150 hover:scale-110">
            <FaFacebookF />
          </a>
          <a href="https://www.linkedin.com/in/asd-flo-558057360/" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer" className="hover:text-blue-300 text-xl transition-transform duration-150 hover:scale-110">
            <FaLinkedinIn />
          </a>
          <a href="https://medium.com/@asdfloteam" aria-label="Medium Profile" target="_blank" rel="noopener noreferrer" className="hover:text-gray-100 text-xl transition-transform duration-150 hover:scale-110">
            <FaMediumM />
          </a>
        </div>
      </div>
      <div className="mt-6 text-center text-xs text-indigo-300/80">
        &copy; {new Date().getFullYear()} asdflo. All rights reserved. | <a href="mailto:info@asdflo.com" className="underline hover:text-indigo-100">info@asdflo.com</a>
      </div>
      {modalOpen && (
        <TermsModal open={modalOpen} onClose={closeModal} title={modalTitle}>
          {modalContent}
        </TermsModal>
      )}
      <ReferralModal open={referralModal.open} onClose={() => setReferralModal({ open: false, role: null })} defaultRole={referralModal.role} />
    </footer>
  );
}
